// const truckColors = []

// for (var i = 0; i < 20; i++) {
//   let maxVal = 0xFFFFFF; // 16777215
//   let randomNumber = Math.random() * maxVal; 
//   randomNumber = Math.floor(randomNumber);
//   let randomNumberStr = randomNumber.toString(16);
//   let randColor = randomNumberStr.padStart(6, '0');   
//   truckColors.push(`#${randColor.toUpperCase()}`)
// }

const truckColors = [
  "#22ff00",
  "#ff0000",
  "#1f3dff",
  "#00cc66",
  "#b03060",
  "#ff6a00",
  "#c28800",
  "#703131",
  "#483d8b",
  "#6b1b68",
  "#00a3a3",
  "#ff00fb",
  "#ff4500",
  "#194f19",
  "#ff1493",
  "#6e6300",
  "#dc143c",
  "#8b4513",
  "#0a0091"
];

export default truckColors;
